import { render, staticRenderFns } from "./PractitionerComponent.vue?vue&type=template&id=f4ed5fb8&scoped=true"
import script from "./PractitionerComponent.vue?vue&type=script&lang=ts"
export * from "./PractitionerComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ed5fb8",
  null
  
)

export default component.exports